export default function getZoomToIds ({ firstRender, state, chartData }) {
	if (!firstRender) {
		// If this isn't the first render, then just let DrilldownManager take
		// care of things
		return null
	}
	if (state?.zoomToIds) {
		// For charts with an initial state set, like exports, briefings,
		// and bookmarks
		return state.zoomToIds
	}

	if (chartData.zoomToIds()) {
		// For charts that have their "startingViewTreeId" set to a
		// leaf node and needed their zoomTo adjusted, see #52600
		return chartData.zoomToIds()
	}

	return null
}
